// @ts-nocheck
import { useState, useEffect } from 'react';
import { getTechnicians } from '../services/supabaseService';

export const useTechnicians = () => {
    const [technicians, setTechnicians] = useState([]);

    useEffect(() => {
        const fetchTechnicians = async () => {
            try {
                const techniciansData = await getTechnicians();
                setTechnicians(techniciansData);
            } catch (error) {
                console.error("Failed to fetch technicians:", error);
            }
        };

        fetchTechnicians();
    }, []);

    return technicians;
};
